// src/app/views/pages_user/bar/rtUsBar.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const UsBarList = Loadable(lazy(() => import("./UsBarList")));
const UsBarExamExam = Loadable(lazy(() => import("./UsBarExam")));
const ApplicationLogin = Loadable(lazy(() => import("./ApplicationLogin")));
const ApplicationInfo = Loadable(lazy(() => import("./ApplicationInfo")));
const PaymentResult = Loadable(lazy(() => import("./PaymentResult")));
const Login = Loadable(lazy(() => import("./Login")));
const UsBarExamReview = Loadable(lazy(() => import("./UsBarExamReview")));
const pathExt = getPathByCdExt(EXAM_TYPES.BAR.rid_cd_ext);

const rtUsBar = [
  { path: `/user/${pathExt}/login`, element: <Login /> },
  { path: `/user/${pathExt}/applogin`, element: <ApplicationLogin /> },
  { path: `/user/${pathExt}/application-info`, element: <ApplicationInfo /> },
  { path: `/user/${pathExt}/payment-result`, element: <PaymentResult /> },
  { path: `/user/${pathExt}/list/:rid_cd_ext/:rid_user`, element: <UsBarList /> },
  { path: `/user/${pathExt}/exam/:rid_cd_ext/:rid_user/:rid_imp`, element: <UsBarExamExam /> },
  { path: `/user/${pathExt}/exam/review/:rid_cd_ext/:rid_imp/:rid_subj/:rid_user/:num_answer`, element: <UsBarExamReview /> }
];
export default rtUsBar;
